import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "chargement en cours...", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "typo__label" }, [
  /*#__PURE__*/_createTextVNode("Examen Clinique"),
  /*#__PURE__*/_createElementVNode("span", { class: "red" }, "*")
], -1)
const _hoisted_6 = {
  key: 0,
  class: "red list-none"
}

import VueMultiselect from 'vue-multiselect';

import { ref, onMounted, computed } from 'vue'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'ExamenCliniqueForm',
  props: {
    state: {},
    v$: {}
},
  setup(__props) {

const props = __props


const store = useStore();

const examenData = computed(() => store.state.examen_clinics.examen_clinic?.data.data)

const asyncFindexamenClinic = (query: string) => {
    store.dispatch("examen_clinics/searchExamenClinics", {search: query, page:  1});
}

onMounted(() => {
    store.dispatch("examen_clinics/getExamen_clinic");
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!examenData.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_unref(VueMultiselect), {
        modelValue: __props.state.description,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.state.description) = $event)),
        options: examenData.value ?? [],
        multiple: true,
        "preserve-search": true,
        "close-on-select": true,
        placeholder: "Rechercher un examen clinique",
        label: "fr_description",
        "track-by": "id",
        loading: __props.state.isLoadingexamenClinic,
        onSearchChange: asyncFindexamenClinic
      }, null, 8, ["modelValue", "options", "loading"]),
      (__props.v$.description.$error)
        ? (_openBlock(), _createElementBlock("li", _hoisted_6, _toDisplayString("s�lectionner l'eamen clinic")))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})